<template>
  <div class="usage-box">
    <div class="label--xsmall">
      BetaScore Limit (Organization)
    </div>

    <div class="usage-value heading--small">
      <span :class="{ 'is-zero': nRemaining <= 0, 'has-value': nRemaining > 0 }">
        {{ nRemaining }}
      </span>/<span>{{ nLimit }}</span>
    </div>

    <div class="viewed label--xsmall">
      You’ve viewed: {{ nViewed }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CalicoUsageLimitBox",
  props: {
    limit: { 
      type: [Number, String], 
      default: 0 
    },
    remaining: { 
      type: [Number, String], 
      default: 0 
    },
    viewed: { 
      type: [Number, String], 
      default: 0 
    }
  },
  computed: {
    nLimit() { 
      const v = Number(this.limit); 
      return Number.isFinite(v) ? v : 0; 
    },
    nRemaining() { 
      const v = Number(this.remaining); 
      return Number.isFinite(v) ? v : 0; 
    },
    nViewed() { 
      const v = Number(this.viewed); 
      return Number.isFinite(v) ? v : 0; 
    }
  }
};
</script>

<style lang="scss">
.usage-box {
  @include inset-space($space-medium);
  @include stack-space($space-medium);
  background: $color-background-secondary;
  border-radius: $radius-small;
  text-align: center;

  .usage-value {
    span { color: $color-text-primary; }
    .has-value { color: $color-lapis; }
    .is-zero   { color: $color-text-error; }
  }

  .viewed { color: $color-text-secondary; }
}
</style>
